"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ButtonFields = require("../../components/form/ButtonFields");

var _ButtonFields2 = _interopRequireDefault(_ButtonFields);

var _InputField = require("../../components/form/InputField");

var _InputField2 = _interopRequireDefault(_InputField);

var _CalendarField = require("../../components/form/CalendarField");

var _CalendarField2 = _interopRequireDefault(_CalendarField);

var _MaskField = require("../../components/form/MaskField");

var _MaskField2 = _interopRequireDefault(_MaskField);

var _immutabilityHelper = require("immutability-helper");

var _immutabilityHelper2 = _interopRequireDefault(_immutabilityHelper);

var _SelectField = require("../../components/form/SelectField");

var _SelectField2 = _interopRequireDefault(_SelectField);

var _Fields = require("../../components/form/Fields");

var _Fields2 = _interopRequireDefault(_Fields);

require("../../assets/css/components/table/TableFilter.css");

var _CheckboxField = require("../form/CheckboxField");

var _CheckboxField2 = _interopRequireDefault(_CheckboxField);

var _FieldsGroup = require("../fields/FieldsGroup");

var _FieldsGroup2 = _interopRequireDefault(_FieldsGroup);

var _Form = require("../form/Form");

var _Form2 = _interopRequireDefault(_Form);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
//import {Form} from 'semantic-ui-react'


var TableFilter = function (_React$Component) {
    _inherits(TableFilter, _React$Component);

    function TableFilter(props) {
        _classCallCheck(this, TableFilter);

        var _this = _possibleConstructorReturn(this, (TableFilter.__proto__ || Object.getPrototypeOf(TableFilter)).call(this, props));

        _this.showFilterArea = function () {
            var displayBoxTable = _this.state.displayBoxTable === 'none' ? 'block' : 'none';
            _this.setState({ displayBoxTable: displayBoxTable });
        };

        _this.cancelFilter = function () {
            var campos = _this.state.camposFiltrando;
            Object.keys(campos).forEach(function (key) {
                campos[key] = '';
            });
            _this.setState({ camposFiltrando: campos });
            _this.showFilterArea();
            _this.props.onFilter('');
        };

        _this.findColumn = function (nomeCampo) {
            var cbCampos = _this.getTableColummProps(_this.props.dataMapper);
            return cbCampos.find(function (c) {
                return c.atributo === nomeCampo;
            });
        };

        _this.onFilter = function (e) {
            e.preventDefault();
            var cbCampos = _this.getTableColummProps(_this.props.dataMapper);
            var toFilter = {};
            cbCampos.forEach(function (c) {
                var valor = null;
                if (_this.state.camposFiltrando[c.atributo] && _this.state.camposFiltrando[c.atributo].length > 0) {
                    valor = _this.state.camposFiltrando[c.atributo];
                    if (c.unmask) {
                        valor = _this.state.camposFiltrando[c.atributo].replace(/[\/.-]/g, "");
                    }
                }
                toFilter[c.atributo] = valor;
            });

            // Object.keys(this.state.camposFiltrando).forEach(c => {
            //     const valor = this.state.camposFiltrando[c]
            //     if(valor.length > 0){
            //         const column = this.findColumn(c)
            //         toFilter.push({campo: column.campo, tipo: column.tipo, valor})
            //     }
            // })

            var url = '';
            cbCampos.forEach(function (c) {
                var valor = _this.state.camposFiltrando[c.atributo];
                if (valor && valor.length > 0 || Number.isInteger(valor) || typeof valor === "boolean") {
                    var valorAux = valor;
                    if (c.unmask) {
                        valorAux = valor.replace(/[\/.-]/g, "");
                    }
                    url = url + "&" + c.atributo + "=" + valorAux;
                }
            });

            _this.props.onFilter(url);
        };

        _this.getTableColummProps = function (dataMapper) {
            var columns = [];
            _this.props.getDataMapped(dataMapper)[0].props.children.forEach(function (c) {
                if (c.props.filter !== undefined) {
                    columns.push(c.props.filter);
                }
            });
            return columns;
        };

        _this.onValorFilterChangeString = function (e, _ref) {
            var name = _ref.name,
                value = _ref.value;

            _this.setState({ camposFiltrando: (0, _immutabilityHelper2.default)(_this.state.camposFiltrando, { $merge: _defineProperty({}, name, value) }) });
        };

        _this.onValorFilterChangeNumber = function (e, _ref2) {
            var name = _ref2.name,
                value = _ref2.value;

            _this.setState({ camposFiltrando: (0, _immutabilityHelper2.default)(_this.state.camposFiltrando, { $merge: _defineProperty({}, name, value.replace(/\D/, '')) }) });
        };

        _this.onSelectClear = function (campo) {
            _this.setState({ camposFiltrando: (0, _immutabilityHelper2.default)(_this.state.camposFiltrando, { $merge: _defineProperty({}, campo, '') }) });
        };

        _this.onChangeBoolean = function (e, _ref3, value) {
            var name = _ref3.name;

            if (value) {
                if (!_this.state.camposFiltrando[name] || _this.state.camposFiltrando[name] === undefined || _this.state.camposFiltrando[name] === null) {
                    _this.onValorFilterChangeString(e, { name: name, value: value });
                } else {
                    _this.onValorFilterChangeString(e, { name: name, value: '' });
                }
            } else {
                if (_this.state.camposFiltrando[name] || _this.state.camposFiltrando[name] === undefined || _this.state.camposFiltrando[name] === null || _this.state.camposFiltrando[name].length === 0) {
                    _this.onValorFilterChangeString(e, { name: name, value: value });
                } else {
                    _this.onValorFilterChangeString(e, { name: name, value: '' });
                }
            }
        };

        _this.onChangeCheck = function (e, _ref4, value) {
            var name = _ref4.name;

            if (_this.state.camposFiltrando[name]) {
                var opcoes = _this.state.camposFiltrando[name];
                if (opcoes.indexOf(value) > -1) {
                    opcoes = opcoes.filter(function (i) {
                        return i !== value;
                    });
                    _this.onValorFilterChangeString(e, { name: name, value: opcoes });
                    return;
                }
                opcoes.push(value);
                _this.onValorFilterChangeString(e, { name: name, value: opcoes });
            } else {
                _this.setState({ camposFiltrando: (0, _immutabilityHelper2.default)(_this.state.camposFiltrando, { $merge: _defineProperty({}, name, [value]) }) });
            }
        };

        _this.onHandlerChangeTarget = function (e) {
            _this.setState({ camposFiltrando: (0, _immutabilityHelper2.default)(_this.state.camposFiltrando, { $merge: _defineProperty({}, e.target.name, e.target.value) }) });
        };

        _this.getFunctionType = function (tipo) {
            if (tipo === 'String' || tipo === 'Select' || tipo === 'Date') return _this.onValorFilterChangeString;
            if (tipo === 'Number') return _this.onValorFilterChangeNumber;
            if (tipo === 'Boolean') return _this.onChangeBoolean;
            if (tipo === 'Check') return _this.onChangeCheck;
        };

        _this.getSelectCombo = function (combo, campo) {
            if (!_this.state.selectValues[campo]) _this.setState({ selectValues: (0, _immutabilityHelper2.default)(_this.state.selectValues, { $merge: _defineProperty({}, campo, combo) }) });
        };

        _this.checkOptionExist = function (atributo, opcao) {
            if (_this.state.camposFiltrando[atributo]) {
                return _this.state.camposFiltrando[atributo].indexOf(opcao) > -1;
            }
            return false;
        };

        _this.clearDate = function (name) {
            _this.setState({ camposFiltrando: (0, _immutabilityHelper2.default)(_this.state.camposFiltrando, { $merge: _defineProperty({}, name, "") }) });
        };

        _this.getFieldToFilter = function (c) {
            var changeFunction = _this.getFunctionType(c.tipo);
            if (c.mascara) {
                var mask = c.mascara.replace(/0/g, 9);
                return _react2.default.createElement(_MaskField2.default, { width: 16, key: c.atributo,
                    name: c.atributo, label: "Filtrar por " + c.coluna,
                    value: _this.state.camposFiltrando[c.atributo],
                    mask: mask, placeholder: c.mascara,
                    onChange: _this.onHandlerChangeTarget });
            }

            if (c.tipo === 'Boolean') {
                return _react2.default.createElement(
                    _Fields2.default,
                    { key: c.atributo, label: "Filtrar por " + c.coluna, width: 16 },
                    _react2.default.createElement(_CheckboxField2.default, { width: 2, rightLabel: true, label: "Sim", name: c.atributo, value: _this.state.camposFiltrando[c.atributo] === true, onChange: function onChange(e, data) {
                            return changeFunction(e, data, true);
                        } }),
                    _react2.default.createElement(_CheckboxField2.default, { width: 2, rightLabel: true, label: "N\xE3o", name: c.atributo, value: _this.state.camposFiltrando[c.atributo] === false, onChange: function onChange(e, data) {
                            return changeFunction(e, data, false);
                        } })
                );
            }

            if (c.tipo === 'Check') {
                return _react2.default.createElement(
                    _Fields2.default,
                    { label: "Filtrar por " + c.coluna, width: 16, key: c.coluna },
                    _react2.default.createElement(
                        "div",
                        { className: "checkbox-filter-area" },
                        c.opcoes.map(function (op) {
                            return _react2.default.createElement(_CheckboxField2.default, { key: op, className: "text-md pl-lg-filter", rightLabel: true, label: op, name: c.atributo, value: _this.checkOptionExist(c.atributo, op), onChange: function onChange(e, data) {
                                    return changeFunction(e, data, op);
                                } });
                        })
                    )
                );
            }

            if (c.tipo === 'Select') {
                if (c.combo.length > 0) {
                    _this.getSelectCombo(c.combo, c.atributo);
                    return _react2.default.createElement(_SelectField2.default, { width: 16, key: c.atributo,
                        name: c.atributo, label: "Filtrar por " + c.coluna,
                        placeholder: "Selecione um " + c.coluna,
                        options: _this.state.selectValues[c.atributo] || [],
                        value: _this.state.camposFiltrando[c.atributo],
                        onChange: changeFunction,
                        onClear: _this.onSelectClear.bind(_this, c.atributo) });
                }
            }

            if (c.tipo === 'Date') {
                return _react2.default.createElement(_CalendarField2.default, { width: 16, key: c.atributo,
                    name: c.atributo, label: "Filtrar por " + c.coluna,
                    value: _this.state.camposFiltrando[c.atributo],
                    onChange: changeFunction, onClear: _this.clearDate.bind(_this, c.atributo), calendarConfig: { type: 'date' } });
            }

            return _react2.default.createElement(_InputField2.default, { width: 16, key: c.atributo,
                name: c.atributo, label: "Filtrar por " + c.coluna,
                value: _this.state.camposFiltrando[c.atributo],
                onChange: changeFunction });
        };

        _this.fieldGroups = function (campos) {
            var total = campos.length;
            var i = 0;
            var caux = [];
            var N_ITENS = 4;
            while (total > 0) {
                if (total > N_ITENS - 1) {
                    caux.push(campos.slice(i, i + N_ITENS));
                } else {
                    caux.push(campos.slice(i, i + total));
                }
                total -= N_ITENS;
                i += N_ITENS;
            }

            return caux.map(function (cx, index) {
                return _react2.default.createElement(
                    _FieldsGroup2.default,
                    { key: index },
                    cx.map(function (c) {
                        return _this.getFieldToFilter(c);
                    })
                );
            });
        };

        _this.getFilter = function () {
            var cbCampos = _this.getTableColummProps(_this.props.dataMapper);
            if (cbCampos.length > 0) return _react2.default.createElement(
                "div",
                { className: "btn-table-filter" },
                _react2.default.createElement(
                    "button",
                    { onClick: _this.showFilterArea, className: "action-option" },
                    _react2.default.createElement(
                        "div",
                        { className: "icon material-icons" },
                        "filter_list"
                    ),
                    _react2.default.createElement(
                        "div",
                        { className: "mdl-tooltip mdl-tooltip--left" },
                        "Filtro"
                    )
                ),
                _react2.default.createElement(
                    "div",
                    { className: "box-table-filter", style: { display: _this.state.displayBoxTable } },
                    _react2.default.createElement(
                        "div",
                        null,
                        _react2.default.createElement(
                            _Form2.default,
                            { onSubmit: _this.onFilter.bind(_this), autoComplete: "off" },
                            _this.fieldGroups(cbCampos),
                            _react2.default.createElement(
                                "div",
                                { className: "align right" },
                                _react2.default.createElement(_ButtonFields2.default, { type: "reset", button: "flat", color: "red", content: "Cancelar", onClick: _this.cancelFilter }),
                                _react2.default.createElement(_ButtonFields2.default, { type: "submit", color: "green", content: "Filtrar" })
                            )
                        )
                    )
                )
            );
        };

        _this.state = {
            displayBoxTable: 'none',
            columns: null,
            selectValues: {},
            camposFiltrando: {}
        };
        return _this;
    }

    /*
        Tipos de Filtro:
        String: {atributo, tipo: String, coluna}
        Number: {atributo, tipo: Number, coluna}
        Mascara: ({atributo, tipo: Number|String, coluna, mascara}
            o tipo mascara recebe o formato da mascara com 0, que vai para o placeholder
            e são substituidos por 1 para serem usados no mask do componente MaskField
        )
        Date:   {atributo, tipo: Date, coluna}
        Boolean:   {atributo, tipo: Boolean, coluna}
        Check:   {atributo, tipo: Check, coluna, opcoes: ['']}
        Select: ({atributo, tipo: Select, coluna, objectCombos}
        )
    */


    _createClass(TableFilter, [{
        key: "render",
        value: function render() {
            return _react2.default.createElement(
                "div",
                null,
                this.getFilter()
            );
        }
    }]);

    return TableFilter;
}(_react2.default.Component);

exports.default = TableFilter;


TableFilter.propTypes = {
    dataMapper: _propTypes2.default.func.isRequired,
    getDataMapped: _propTypes2.default.func.isRequired,
    onFilter: _propTypes2.default.func
};


//////////////////
// WEBPACK FOOTER
// ../react-template/lib/components/table/TableFilter.js
// module id = 597
// module chunks = 0